import React from 'react';

const NextIcon = ({ className = '' }) => (
  <svg
    width="8"
    height="13"
    viewBox="0 0 8 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`inline-block ${className}`}
  >
    <path
      d="M1.20595 13L8 6.5L1.20595 0L0 1.15375L5.58811 6.5L0 11.8462L1.20595 13Z"
      fill="currentColor"
    />
  </svg>
);

export default NextIcon;
